import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  popularity: number;
  status: string;
  tags: string[];
}

export default function ComicCard({ id, title, author, cover, rating, popularity, status, tags }: ComicCardProps) {
  const tagMap = categories.reduce<Record<string, string>>((acc, cat) => {
    acc[cat.slug] = cat.name;
    return acc;
  }, {});

  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={cover}
          alt={title}
          title={`${title} - 新新漫画推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium text-white ${
            status === '连载中' ? 'bg-primary-500' : 'bg-secondary-500'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/60 rounded-full px-2 py-0.5">
          <i className="ri-star-fill text-yellow-400 text-xs" />
          <span className="text-white text-xs font-medium">{rating}</span>
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{author}</p>
        <div className="flex items-center gap-1.5 mt-2 flex-wrap">
          {tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 rounded text-[10px] bg-background-200 text-foreground-600"
            >
              {tagMap[tag] || tag}
            </span>
          ))}
          <span className="text-[10px] text-foreground-400 ml-auto">
            <i className="ri-eye-line mr-0.5" />
            {(popularity / 10000).toFixed(1)}万
          </span>
        </div>
      </div>
    </Link>
  );
}